function initProductSwiper() {
  var productSwiper = new Swiper('.u-product-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      250: { slidesPerView: 1 }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  function updateDates() {
    const now = new Date();
    document.querySelectorAll('.doubleusps').forEach(function (element) {
      const target = element.querySelector('[data-shipping-date], #cstmdate');
      if (!target || !element.dataset.giorni || !element.dataset.mesi) return;
      const days = element.dataset.giorni.split(',').map(function (value) { return value.trim(); });
      const months = element.dataset.mesi.split(',').map(function (value) { return value.trim(); });
      const offset = Number(element.dataset.ndays || window.nDays || 1);
      if (!Number.isFinite(offset) || days.length !== 7 || months.length !== 12) return;
      const future = new Date(now);
      future.setDate(future.getDate() + offset);
      target.textContent = days[future.getDay()] + ', ' + future.getDate() + ' ' + months[future.getMonth()];
    });
    if (!document.querySelector('.doubleusps [data-shipping-date], .doubleusps #cstmdate')) return;
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    setTimeout(updateDates, Math.max(1000, midnight.getTime() - now.getTime()));
  }
  updateDates();
});
